import React from 'react';
import type { EvaluationPlanWebDocumentTemplate } from '../../utils/evaluationPlanWebDocumentTemplateStorage';
import { WEB_DOCUMENT_DEFAULT_TEMPLATE_ID } from '../../types/evaluationPlanWebDocument';

const EvaluationPlanWebDocumentTemplateTabs: React.FC<{
  templates: EvaluationPlanWebDocumentTemplate[];
  activeTemplateId: string;
  onSelect: (templateId: string) => void;
  onRename: (template: EvaluationPlanWebDocumentTemplate) => void;
  onDelete: (template: EvaluationPlanWebDocumentTemplate) => void;
}> = ({ templates, activeTemplateId, onSelect, onRename, onDelete }) => {
  return (
    <div
      className="cp-admin-legal-subtabs cp-evaluation-plan-web-doc-template-tabs"
      role="tablist"
      aria-label="기준안 양식"
    >
      <span className="cp-evaluation-plan-web-doc-template-tabs-label">기준안 양식 :</span>
      <div
        className={`cp-admin-learning-template-item cp-evaluation-plan-web-doc-template-item${activeTemplateId === WEB_DOCUMENT_DEFAULT_TEMPLATE_ID ? ' is-active' : ''}`}
        role="tab"
        aria-selected={activeTemplateId === WEB_DOCUMENT_DEFAULT_TEMPLATE_ID}
        tabIndex={0}
        onClick={() => onSelect(WEB_DOCUMENT_DEFAULT_TEMPLATE_ID)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onSelect(WEB_DOCUMENT_DEFAULT_TEMPLATE_ID);
          }
        }}
      >
        <div className="cp-admin-learning-template-tab">기본</div>
      </div>

      {templates.map((template) => {
        const active = activeTemplateId === template.id;
        return (
          <div
            key={template.id}
            className={`cp-admin-learning-template-item cp-evaluation-plan-web-doc-template-item${active ? ' is-active' : ''}`}
            role="tab"
            aria-selected={active}
            tabIndex={0}
            onClick={() => onSelect(template.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(template.id);
              }
            }}
          >
            <div className="cp-admin-learning-template-tab">{template.name}</div>
            <div className="cp-admin-learning-template-item-actions">
              <button
                type="button"
                className="track-icon-button cp-admin-learning-template-icon-btn"
                title="양식 이름 수정"
                onClick={(e) => {
                  e.stopPropagation();
                  onRename(template);
                }}
                aria-label={`${template.name} 양식 이름 수정`}
              >
                <img src="/edit.svg" alt="" className="track-icon" />
              </button>
              <button
                type="button"
                className="track-icon-button cp-admin-learning-template-icon-btn cp-admin-learning-template-icon-btn-delete"
                title="양식 삭제"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(template);
                }}
                aria-label={`${template.name} 양식 삭제`}
              >
                <img src="/Trash.svg" alt="" className="track-icon" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EvaluationPlanWebDocumentTemplateTabs;
